import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../assets/vendor/swiper/swiper-bundle.min.css"; // Assure-toi d'importer les styles globaux
import { useTranslation } from "react-i18next";

import testimonialsBg from "../assets/img/testimonials-bg.jpg";
import testimonials2 from "../assets/img/testimonials/Georges_bassil.jfif";
import testimonials1 from "../assets/img/testimonials/Ahmed.jpeg";
import testimonials3 from "../assets/img/testimonials/nasire.jfif";


const testimonials = [
  {
    img: testimonials1,
    name: "ahmed LABIDI",
    title: "CTO - Kenzo (LVMH)",
    text: "J'ai connu Hovig lors de sa première expérience. J' ai repéré les capacités énormes de ce jeune homme. Une énergie incroyable au service de la DSI. Des solutions pertinentes et SMART face aux challenges énormes sur AWS. Un bel état d'esprit que je recommande.",
  },
  {
    img: testimonials2,
    name: "Georges BASSIL",
    title: "Head of Digital Workplace - Safran",
    text: "Hovig est un expert en architecture cloud AWS, capable de concevoir des solutions performantes, sécurisées et évolutives. Son approche pragmatique et son sens de l’innovation en font un atout précieux pour toute entreprise. Toujours à l’écoute, il sait accompagner les équipes vers une meilleure adoption du cloud. Je le recommande vivement !",
  },
  {
    img: testimonials3,
    name: "Nasire ABDUL KHUDOOS",
    title: "CEO - Beekom",
    text: "Travailler avec Hovig chez Atalian a été une expérience enrichissante. Il se distingue par sa capacité à intégrer rapidement de nouveaux concepts et par son énergie impressionnante au service de la DSI. Face aux défis majeurs sur AWS, il apporte des solutions à la fois pertinentes et intelligentes. Son état d’esprit positif et son professionnalisme en font un atout précieux.",
  },

];

const Testimonials = () => {
  const { t } = useTranslation();
  return (

    <>
        <div className="container section-title" data-aos="fade-up">
        <h1 className="services-title">{t("Friends")}</h1>
    </div>
    
    <section id="testimonials" className="testimonials section accent-background">
      <img src={testimonialsBg} className="testimonials-bg" alt="Testimonials Background" />

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <Swiper
          modules={[Pagination, Autoplay]}
          loop={true}
          speed={600}
          autoplay={{ delay: 5000 }}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          className="init-swiper"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-item">
                <img src={testimonial.img} className="testimonial-img" alt={testimonial.name} />
                <h3>{testimonial.name}</h3>
                <h4>{testimonial.title}</h4>
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="bi bi-star-fill"></i>
                  ))}
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left"></i>
                  <span>{testimonial.text}</span>
                  <i className="bi bi-quote quote-icon-right"></i>
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
    </>
  );
};

export default Testimonials;
